<template>
  <fieldset>
    <FormulateInput
      name="gender"
      :options="inputOptions"
      type="radio"
      :label="i18n.form.labels.gender"
      validation="required"
      :validation-messages="i18n.form.validations.gender"
    />
  </fieldset>
</template>

<script>
export default {
  name: 'FieldsGender',
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    onlyAllowKnownOptions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputOptions() {
      let options = {
        male: this.i18n.form.labels.genderoptions.male,
        female: this.i18n.form.labels.genderoptions.female,
        other: this.i18n.form.labels.genderoptions.other,
        ...(this.onlyAllowKnownOptions ? {} : { unknown: this.i18n.form.labels.genderoptions.unknown }),
      };
      return options;
    },
  },
};
</script>
